/* eslint-disable */
import { endpoints } from '../Constants';
import { authHeader } from '../Helpers';
import handleResponse from './helpers';

// Internal-only Business Config page. The backend checks that the user holds an internal role and
// only serves the customer the console is logged in for (the clientId header).

function listCustomers() {
	return fetch(`${endpoints.BUSINESS_CONFIG}/customers`, {
		method: 'GET',
		headers: authHeader(),
	}).then(handleResponse);
}

function getBusinessConfig(customerId) {
	return fetch(`${endpoints.BUSINESS_CONFIG}/${customerId}`, {
		method: 'GET',
		headers: authHeader(),
	}).then(handleResponse);
}

// changes: [{ section: 'column' | 'configs' | 'reportConfigs', key, from, wasSet, to, remove }]
// `from` / `wasSet` are what the page loaded; the API refuses the save if someone changed them since.
function saveBusinessConfig(customerId, changes) {
	return fetch(`${endpoints.BUSINESS_CONFIG}/${customerId}`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
		body: JSON.stringify({ changes }),
	}).then(handleResponse);
}

const businessConfigServices = {
	listCustomers,
	getBusinessConfig,
	saveBusinessConfig,
};

export default businessConfigServices;
